export const EditFormValueNormlizer = (StateBank) => {
  const MedicalFormattedValues =
    StateBank?.GroupElements?.map((GroupElement) => {
      if (
        GroupElement?.ElsFormDetail?.ElsRecord?.Type ===
          'ComboBox' ||
        GroupElement?.ElsFormDetail?.ElsRecord?.Type ===
          'RadCheckedDropDownList'
      ) {
        return {
          base64: '',
          idcommand: GroupElement?.IdCommand,
          iddetail: GroupElement?.ElsFormDetail?.Id,
          element: GroupElement?.ElsFormDetail,
          UiValue: GroupElement,
          value: GroupElement?.Value,
          name: GroupElement?.ElsFormDetail?.ElsRecord.Name,
          isEdit: GroupElement.Value.length > 0,
        };
      } else {
        return {
          base64: GroupElement?.ImageBase64 ?? '',
          iddetail: GroupElement?.ElsFormDetail?.Id,
          element: GroupElement?.ElsFormDetail,
          UiValue: GroupElement,
          value: GroupElement?.Value,
          name: GroupElement?.ElsFormDetail?.ElsRecord.Name,
          isEdit:
            Number(GroupElement?.Value) !== 0
              ? GroupElement.Value.toString().length > 0
              : false,

          ...(GroupElement?.ElsFormDetail?.ElsRecord
            ?.Type === 'RadioButton' && {
            PannelNo:
              GroupElement.ElsFormDetail.RadionPanelNo,
          }),
        };
      }
    });

  return (
    MedicalFormattedValues?.sort((a, b) => {
      return a.element.CodeForWeb - b.element.CodeForWeb;
    }) ?? []
  );
};
